import React from 'react';
import { env } from '@admitkard/uiutils/env';
import { careerCss } from 'components/Career/Career.css';

interface CareerJobsData {
  imgUrlWeb: string;
  imgUrlMobile: string;
  label: string;
}

const JOBS_DATA: CareerJobsData[] = [
  {
    imgUrlMobile: 'images/career-page/icons/product_&_technology_icon_(mobile).svg',
    imgUrlWeb: 'images/career-page/icons/product_&_technology_icon_(web).svg',
    label: 'Product & Technology'
  },
  {
    imgUrlMobile: 'images/career-page/icons/marketing_icon_(mobile).svg',
    imgUrlWeb: 'images/career-page/icons/marketing_icon_(web).svg',
    label: 'Marketing'
  },
  {
    imgUrlMobile: 'images/career-page/icons/businees_icon_(mobile).svg',
    imgUrlWeb: 'images/career-page/icons/business_Icon_(web).svg',
    label: 'Business & Consulting'
  },
  {
    imgUrlMobile: 'images/career-page/icons/finance_icon_(mobile).svg',
    imgUrlWeb: 'images/career-page/icons/Finance_icon_(web).svg',
    label: 'Finance Management'
  },
  {
    imgUrlMobile: 'images/career-page/icons/sale_icon_(mobile).svg',
    imgUrlWeb: 'images/career-page/icons/sales_icon_(web).svg',
    label: 'Sales & Operations'
  }
];

const Jobs: React.FunctionComponent = () => {
  return (
    <>
      <div className='job-wrapper'>
        <h1 className='font-f'>Popular Job Category</h1>
        <div className='job-cards-wrapper font-f'>
          {
            JOBS_DATA.map(jobData => {
              return (
                <div key={jobData.imgUrlWeb} className='job-card-container'>
                  <div className='job-card'>
                    <div className='job-card-content-wrapper'>
                      <img className='img-mobile' src={env.getAssetUrl(jobData.imgUrlMobile)} alt={jobData.label} />
                      <img className='img-web' src={env.getAssetUrl(jobData.imgUrlWeb)} alt={jobData.label} />
                      <span className='job-card-text'>{jobData.label}</span>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
      <style jsx>{careerCss}</style>
    </>
  );
};

export {Jobs};
